import { render } from "./asideMenuItem.vue?vue&type=template&id=0de2e0b8"
import script from "./asideMenuItem.vue?vue&type=script&lang=js"
export * from "./asideMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__